export default __webpack_public_path__ + "static/media/awesome-xing-square.10ae371e.svg";